export default {
  'AUTH': {
    'CONFIRM_PASSWORD': 'Confirmar contraseña',
    'EMAIL': 'Email',
    'EMPTY_EMAIL': 'El correo electrónico no puede estar vacío.',
    'EMPTY_PASSWORD': 'La contraseña no puede estar vacía.',
    'FORGOT_PASSWORD': 'Se te olvidó tu contraseña',
    'INVALID_EMAIL': 'Por favor, proporcione un correo electrónico válido.',
    'INVALID_PASSWORD': 'La contraseña debe tener al menos {MINIMUM} caracteres.',
    'IDENTICAL_PASSWORD': 'Las contraseñas deben ser idénticas.',
    'LINK_EXPIRED': 'Enlace expirado.',
    'LINK_USED': 'Alguien ya ha usado este enlace. Si no es usted, vuelva a restablecer la contraseña.',
    'LOGIN': 'Iniciar sesión',
    'NEW_PASSWORD': 'Nueva contraseña',
    'PASSWORD': 'Contraseña',
    'PASSWORD_UPDATED': 'Se actualizó con éxito la contraseña.',
    'RESET_LINK_SENT': 'El enlace de restablecimiento ha sido enviado a un correo electrónico registrado.',
    'RESET_PASSWORD': 'Restablecer la contraseña',
    'SUBMIT': 'Enviar',
    'USER_LOGIN': 'Inicio de sesión de usuario',
    'USER_NOT_FOUND': 'Usuario no encontrado. Por favor, póngase en contacto con el administrador.',
    'PWD_CHANGE': 'Cambia la contraseña',
    'PWD_CURRENT': 'contraseña actual'
  },
  'ERROR': {
    'COMMON': 'Se produjo un error. Inténtalo de nuevo.'
  },
  'HEADER': {
    'TRIAL_USER': 'Eres un usuario de prueba. El período de prueba finaliza en {END_DATE}.',
    'NOTIFY_MSG': 'Tienes {len} notificaciones',
    'CLEAR': 'Claro',
    'TEMPLATES': 'Plantillas',
    'FORMS': 'Formularios',
    'UPLOAD_FORM': 'Cargar Formulario',
    'REPORTS': 'Informes',
    'PROFILE': 'Perfil',
    'USERS': 'Usuarios',
    'LOGS': 'Historial',
    'SETTINGS': 'Ajustes',
    'LOGOUT': 'Cerrar sesión',
    'ACCOUNTS': 'Cuentas',
    'MODELS': 'Modelos',
    'Features': 'Características'
  },
  'TEMPLATE': {
    'DATE_FORMAT': 'Formato de fecha',
    'ADD_NEW': 'Agregar una nueva plantilla',
    'ENABLE_AUTO_CORRECT': 'Habilitar corrección automática: ',
    'CLONE': 'Clona una plantilla desde otra cuenta.',
    'CREATE_NPI_GROUP': 'Crear grupo NPI',
    'DATA_TYPE': 'Datos Tipo',
    'DELETE_CONTENT': "¿Desea eliminar esta  '{TEMPLATE_TITLE}' plantilla?",
    'DELETE_MAP': 'Borrar Mapping (Cmd + d)',
    'DELETE_MODAL': 'Eliminar asignaciones',
    'DELETE_MODAL_CONTENT': '¿Estás seguro, quieres eliminar el campo? ?',
    'DRAW': 'Dibu',
    'DISABLE_FORM': 'Deshabilitar para envío de formulario',
    'ENABLE_FORM': 'Habilitar para envío de formulario',
    'ENTER_TITLE': 'Ingrese título....',
    'ENTER_DESCR': 'Introduzca  plantilla descripción',
    'GRP_NAME': 'Grupo Nombre',
    'GRP_TYPE': 'Grupo Tipo',
    'KEY': 'Llave',
    'MAPPING_CATEGORY': 'Categoría',
    'MAPPINGS': 'Mapeos:',
    'CASE': 'Caso',
    'MSG_ADDED': 'Plantilla agregada con éxito.',
    'MSG_REMOVED': 'Plantilla eliminada con éxito..',
    'MSG_SAVED': 'Los cambios del editor se guardan con éxito.',
    'MSG_SAVE_FAIL': 'Algo salió mal. El ahorro falló...',
    'NEXT_PAGE': 'Ir a la página siguiente',
    'NOTHING': 'Aucun modèle trouvé!',
    'ESMMAPPINGS': 'Asignaciones de servicios externos',
    'REDACT_FIELD': 'Redact Field',
    'SHOW_FIELD': 'Show Field',
    'TEMPLATE_VERSION_UPDATE': '¿Desea clonar las asignaciones de campos en la pantalla de asignación de servicios a la nueva versión de la plantilla?',
    'ESM_CLONING': 'Se clonarán las asignaciones de servicios externos',
    'ORTF_CLONING': 'Las asignaciones ORTF se clonarán',
    'SV_CLONING': 'Las validaciones de servicio se clonarán',
    'HL7_CLONING': 'Las asignaciones HL7 se clonarán',
    'CV_CLONING': 'Las asignaciones Custom Validations se clonarán',
    'NPI_GROUP': 'NPI grupo',
    'OLDER_VERSIONS': 'Las versiones anteriores no se pueden editar',
    'PREV_PAGE': 'Regresar a la pagina anterior',
    'REDO': 'Rehacer (Cmd + Shift + z)',
    'REQ': 'Necesario',
    'REQ_TYPE': 'Seleccionar tipo de proceso',
    'REQ_FILE': 'El archivo no puede estar en blanco',
    'REQ_TITLE': 'El título no puede estar en blanco',
    'SAVE': 'Salvar (Cmd + s)',
    'SAVE_CHANGES': '¿Te gusta guardar los cambios antes de salir del editor?',
    'SELECT': 'Seleccionar (Esc)',
    'SELECT_DATA_TYPE': 'Por favor, verifique el tipo de datos',
    'SELECT_DATE_FORMAT': 'Por favor seleccione formato de fecha',
    'SELECT_TYPE': 'Por favor selecciona tipo',
    'SELECT_FROM_ACCOUNT': 'De la cuenta',
    'SELECT_TO_ACCOUNT': 'A la cuenta',
    'SELECT_ACCOUNT': 'Seleccionar cuenta',
    'SELECT_TEMPLATE': 'Seleccionar plantilla',
    'SELECT_CASE': 'Seleccione el caso',
    'TEMPLATE': 'Modelo',
    'THEME': 'Tema',
    'THUMBNAIL': 'Miniatura',
    'TRAIN': 'Entrenar',
    'TRAIN_BASE': 'Train Base Template:',
    'TYPE': 'Tipo',
    'UPDATE_MAP': 'Actualización de mapeo',
    'UPDATE_GRP': 'Actualizar grupo',
    'UNDO': 'Deshacer (Cmd + z)',
    'UNSAVE': 'Cambios no guardados',
    'ZOOM_IN': 'Acercar (Cmd + +)',
    'ZOOM_OUT': 'Alejar (Cmd + -)',
    'IMPORT': 'Importar',
    'EXPORT': 'Exportar',
    'UPLOAD_MAPPINGS': 'Cargar archivo de asignaciones'
  },
  'TEMPLATE_VIEW': {
    'ID': 'Carné de identidad',
    'PAGES': ' PÁGINA(S)',
    'TOTAL_PAGES': 'Paginas totales',
    'UPDATED_AT': 'Actualizado en',
    'VIEW': 'VER:'
  },
  'DATA_TYPE': {
    'ALPHA': 'Alfabetos',
    'ALPHANUM': 'Alfanumérico',
    'ALPHANUMSPC': 'Alfanumérico With Spaces',
    'BLOCK': 'Bloquear',
    'CHECKBOX': 'Casilla de verificación',
    'CITY': 'Ciudad',
    'COMBINE_DATA': 'Datos combinados',
    'CHECKBOX_TEXT': 'Texto de casilla de verificación',
    'DATE': 'Fecha',
    'DEFAULT': 'Defecto',
    'EITHER': 'Cualquiera o Elección',
    'LOGICAL': 'Lógico',
    'MULTI_CHOICE': 'Múltiple Elección',
    'NPI': 'NPI',
    'NUMERIC': 'Numérico',
    'STATE': 'Estado',
    'TABLE_COLUMN': 'Tabla ( Datos de la columna )',
    'TABLE_ENTRY': 'Entrada de tabla',
    'TABLE_HEADER': 'Encabezado de tabla',
    'TABLE_ROW': 'Tabla ( Datos de la fila )',
    'TEXT': 'Texto',
    'ZIPCODE': 'Código postal',
    'CAPITALIZE': 'Ponga en mayúscula la primera letra de campo',
    'UPPER_CASE': 'Mayúscula',
    'LOWER_CASE': 'Minúscula'
  },
  'COLOR': {
    'BLUE': 'Azul',
    'GREEN': 'Verde',
    'RED': 'Rojo'
  },
  'UPLOAD_DROPDOWN': {
    'ENROLLMENT_FORMS': 'Formularios de inscripción',
    'SELECT': 'Seleccionar',
    'AUTO': 'Partido automático',
    'PLAIN': 'Texto sin formato',
    'INSURANCE': 'Tarjeta de seguro',
    'INSU_F_B': 'Tarjetas de seguro delanteras y traseras',
    'MANUAL': 'Manual',
    'DL': 'Licencia de conducir/ID del votante',
    'INVOICE': 'Factura',
    'EXCEL': 'Libro de Excel',
    'LEASE': 'Documento de arrendamiento',
    'SLA': 'Acuerdo de licencia de software',
    'AUS_LEASE': 'Documento de arrendamiento australiano',
    'TRIAGING': 'triaje',
    'BIOTRONIK': 'Biotronik',
    'MEDTRONIC2': 'Medtronic-2',
    'BOSTON': 'Boston Scientific',
    'MEDTRONIC': 'Medtronic'
  },
  'FORMS': {
    'ROTATE_LEFT': 'Girar a la izquierda',
    'ROTATE_RIGHT': 'Gira a la derecha',
    'IMAGE_ROTATE_SUCCESS': 'Rotación de imagen exitosa',
    'IMAGE_ROTATE_FAIL': 'Falló la rotación de la imagen',
    'MULTI_USER_MODAL': 'ADVERTENCIA',
    'MULTI_USER_ALERT_MSG': 'Actualmente, otro usuario está viendo este documento. Valide amablemente otro documento',
    'ACCEPT_PERMISSION_ERROR': 'No se puede aceptar el formulario que se requiere permiso.',
    'NEXT_FORM': '<< Documento siguiente',
    'PREV_FORM': 'Documento anterior >>',
    'SELECT_MODEL': 'Seleccionar modelo',
    'MODEL_NAME': 'Nombre del modelo',
    'MODEL_NAME_ERR': 'El nombre del modelo no puede estar en blanco',
    'USE_TITLE': 'Use el mismo título para todas las formas',
    'CONF_RANGE': 'Rango de confianza',
    'CHECK_ELIG_BTN_LABEL': 'Verificar elegibilidad',
    'CHECK_ELIG_SUCC_MESSAGE': 'Verificación de elegibilidad exitosa',
    'CHECKING_ELIG_BTN_LABEL': 'Comprobación de elegibilidad',
    'AVG_CONF': 'Confianza media',
    'COMP_IMAGES': 'Comparar con las imágenes subidas',
    'NO_LINE_ITEMS': 'No hay elementos de línea para mostrar ...',
    'AUTO_CORRECT': "Corrección automática'",
    'AUTO_CORRECT_CONTENT': 'El valor actualizado se utilizará en el futuro, ¿está seguro de que desea ahorrar?',
    'ACCEPT': 'Aceptar',
    'VERIFY': 'Verificar',
    'APPROVED': 'APROBADO',
    'ADD_FIELD': 'Agregue Field',
    'ALL': 'Para todas las Formas',
    'CON_SCORE': 'Confianza Score',
    'CHANGE_LABEL': 'Cambiar Etiqueta',
    'CHOOSE': 'Elija un formulario...',
    'DELETE_CONTENT': '¿Desea eliminar esta {FIELD_NAME} field?',
    'DESCRIPT_PLACE': 'Ingresa descripción del formulario',
    'DROP_SCANNED': 'Haga clic aquí / Arrastra y suelta archivos aquí para procesar',
    'DROP_TEMP_SCANNED': 'Haga clic aquí / arrastre y suelte archivos para cargar',
    'EDITED': 'EDITED',
    'EXPORT_ERROR': 'Error de asignaciones de exportación de Salesforce',
    'FORCED_TEMPLATE': 'Plantilla forzada',
    'LABEL': 'Etiqueta',
    'LABEL_NAME': 'Etiqueta Nombre',
    'MATCH': 'Coincidencia',
    'MATCHING_TEMPLATE': 'Ver plantilla a juego',
    'MSG_ACCEPT': 'Formulario aceptado',
    'MSG_DEL': 'Datos borrados con éxito',
    'MSG_LABEL': 'Etiqueta cambiada con éxito',
    'MSG_SUCESS': 'Datos actualizados con éxito',
    'MSG_WARN': 'El formulario cargado no se procesa',
    'NOTHING': 'No hay datos para mostrar......',
    'ONLY': 'Solo para esta forma',
    'PENDING': 'PENDIENTE',
    'PAGES_WITH_DATA': 'Paginas con datos',
    'PROCESS_TYPE': 'Tipo de proceso',
    'PROCESSED_DATA': 'Datos procesados',
    'PROCESSING_STAT': 'Los formularios subidos se están procesando ... Por favor, espere',
    'PROCESSED_STAT_ONE': 'Nuevo formulario ha sido procesado. Haga clic para actualizar',
    'PROCESSED_STAT_MANY': 'Se han procesado nuevos formularios. Haga clic para actualizar',
    'REJECTED': 'REJECTED',
    'REQ_TITLE': 'Título no puede estar en blanco',
    'REQ_LABEL': 'Nombre no puede estar en blanco',
    'REQ_FILE': 'Archivo no puede estar en blanco',
    'SELECT_PAGE_NUM': 'Página: ',
    'TABLE_DATA': 'Datos de tabla',
    'TEMPLATE': 'Modelo',
    'TITLE_PLACE': 'Título del formulario ...',
    'UPLOAD_PROCESS': 'Cargar y Procesar ...',
    'UPLOADING': 'Cargando ...',
    'UPLOAD_A_FORM': 'Cargar un formulario escaneado',
    'UPLOAD_MULTI_FORMS': 'Carga de formularios',
    'VALUE': 'Valor',
    'VALIDATION_HEADER': 'Por favor corrija / arregle los siguientes campos',
    'VALIDATE_SIGNATURE': 'Por favor apruebe / rechace la firma para verificar',
    'VALIDATIONS': 'Errores de validación',
    'REQUIRED_FIELDS_VALIDATION': 'Errores de campos obligatorios',
    'SERVICE_VALIDATION': 'Errores de validación del servicio',
    'VALIDATION_ERROR': 'Errores de validación',
    'OPTIONAL_FIELDS_VALIDATION': 'Errores de campos opcionales'
  },
  'WORKFLOW': {
    'LOCK_TITLE': 'Bloqueado por {userName}',
    'LOCK_ALERT_MSG': 'Voulez-vous déverrouiller cet enregistrement?',
    'ACTIONS': 'Acción',
    'ANALYSE': 'Analizar',
    'ANALYSIS': 'Análisis',
    'TITLE': 'Nombre del paciente',
    'INVOICE': 'Factura',
    'DOWNLOAD': 'Descargar',
    'FILTER': 'Aplicar filtros',
    'FILTERS': 'filtros',
    'MATCH': 'Coincidencia',
    'GROUP_ID': 'ID de Grupo',
    'PROCESSED_FORMS': 'Formularios procesados',
    'PROCESS_PAGE_COUNT': 'Recuento de páginas procesadas',
    'MATCHED_PAGE_COUNT': 'Número de páginas coincidentes',
    'REJECT_PAGE_COUNT': 'Recuento de páginas rechazadas',
    'SEARCH': 'Busqueda',
    'UPDATED_AT': 'Actualizado en',
    'DELETE_FORM': "¿Quieres borrar este formulario '{FORM_TITLE}'?",
    'FAX_NUMBER': 'Número de fax',
    'ENTER_FAX_NUMBER': 'Ingrese el número de fax',
    'DELETE': 'Borrar',
    'FORM_INFO_HEADER': 'Detalles de formularios procesados',
    'DELETE_MULTIPLE': 'Eliminar formas mutliples',
    'REPROCESS': 'Reprocesar',
    'MAX_RETRIES': 'Alcanzado Max cuenta de reintentos.',
    'MOVE_TO_MATCHED': 'Mover a la cola coincidente',
    'SF_STATUS': 'Estado',
    'DOCUMENT_TYPE': 'Tipo de Documento',
    'PRODUCT': 'Producto',
    'REPORT': 'Informe'
  },
  'ANALYTICS': {
    'TOTAL_FORMS': 'Total de formularios recibidos',
    'CONFIDENCE': 'Confianza (%)',
    'CONFIDENCE_AVG': 'Promedio de confianza por plantilla',
    'DAILY_REPORT': 'Reporte diario',
    'FILTER_TEMPLATES': 'Filtrar por Plantillas',
    'FORM_WORKFLOW_STATS': 'Estadísticas del flujo de trabajo',
    'IDENTIFIED': 'Identificado',
    'RECENT_FORMS': 'Formularios recientes',
    'FAXES_RECEIVED': 'Número total de Formularios de pacientes recibidos',
    'FAXES_IDENTIFIED': 'Número total de Formularios de pacientes identificados',
    'FAXES_READABLE': 'Número total de Formularios de pacientes legibles',
    'FAXES_REJECTED_ORIGIN': 'Total de pacientes rechazados según el país',
    'FAXES_REJECTED_BY_REASON': 'Total de formularios de pacientes rechazados debido a la legibilidad',
    'FAXES_UNPROCESSED': 'Total de formularios de pacientes no coincidentes con la plantilla',
    'REJECTED': 'Razón Rechazada',
    'WEEKLY_REPORT': 'Reporte semanal',
    'TOTAL_PROCESSED': 'Procesado',
    'TOTAL_REJECTED': 'Rechazado',
    'TEMPLATE': 'Modelo',
    'PROCESS_TYPE': 'Tipo de proceso',
    'SELECT_PROCESS_TYPE': 'tipo de proceso',
    'PAGES': 'Páginas',
    'RECENT_FORM_MSG': 'Los formularios recientes generados en el CSV pertenecerán únicamente al intervalo de fechas seleccionado.  ',
    'REPORT_CONTENT': 'Reportar contenido'
  },
  'CONFIGURED': {
    'ADD_ROLE': 'Agregar Rol',
    'ADD_GROUP': 'Agregar nuevo Campos',
    'ADD_ALIAS': 'Agregar alias',
    'ADD_FIELD_ALIAS': 'Añadir alias de campo',
    'ADD_NEW_KEYS': 'Agregar nuevas claves',
    'B_PREVIEW': 'Vista previa borde',
    'CONFIDENCE_COLORS': 'Colores de confianza',
    'CC_SUCCESS': 'Los colores de confianza se actualizan con éxito',
    'COLOR': 'Color',
    'CREATE': 'Crear',
    'IMPORT_MAPPINGS': 'Importar asignaciones',
    'EDIT_GROUP': 'Editar grupo',
    'EDIT_ALIAS': 'Editar alias',
    'FORM_ORDER': 'Orden de procesamiento de formulario',
    'FIELD_TYPE': 'Tipo de campo',
    'FIELD_EXISTS': 'Ya existe el campo',
    'FIELDS': 'Campos',
    'FIELDS_ALIASES': 'Alias de campo',
    'NEW_ROLE': 'Nuevo rol',
    'NOTE': 'Nota: Arrastra / suelta los elementos para cambiar el orden de procesamiento del formulario',
    'PREVIEW': 'Avance',
    'PROCESS_ORDER_SUCCESS': 'La orden de procesamiento se actualizó correctamente',
    'RANGE': 'Distancia',
    'ROLE_CREATED': ' el rol se crea con éxito',
    'ROLE_MANAGE': 'Gestión de roles',
    'ROLE_NAME': 'Nombre de rol',
    'ROLE_NOTE': 'Nota: Arrastre / suelte los elementos para cambiar el orden de los roles',
    'ROLE_ORDER': 'Orden de roles',
    'ROLE_ORDER_SUCCESS': 'Role Order se actualiza con éxito',
    'ROLE_SUCCESS': 'Los roles se actualizan con éxito',
    'SELECT_ROLE': 'Seleccionar rol',
    'PROCESS_TYPE': 'Tipos de procesos suscritos',
    'FIELD': 'Nombre del campo',
    'SUBSCRIBE_MODAL': 'Suscríbase a un nuevo tipo de proceso',
    'UNSUBSCRIBE_MODAL': 'Darse de baja un tipo de proceso',
    'SUBSCRIBE_PT': 'Suscrito con éxito un nuevo tipo de proceso',
    'UNSUBSCRIBE_PT': 'Cancelada exitosamente',
    'ENTER_SECTION_NAME': 'Ingrese el nombre de la sección',
    'SECTION_ORDER': 'Orden de sección',
    'SECTION_NOTE': 'Nota: Arrastre / suelte los elementos para cambiar el orden de la sección',
    'SECTION_ORDER_SUCCESS': 'El orden de la sección se ha actualizado correctamente',
    'HL7_TEMPLATES': 'Plantillas HL7'
  },
  'TRAILS': {
    'AUDIT_TRAILS': 'Pistas de Auditoría',
    'CREATED_AT': 'Registrado en',
    'LOCATION': 'Ubicación',
    'PATH': 'Camino',
    'CUSTOM_DATE_LOGS': 'Registros de fecha personalizados'
  },
  'USERS': {
    'ACCOUNT': 'Cuenta',
    'ADD_NEW': 'Agregar nuevos usuarios',
    'EMAIL': 'Correo electrónico',
    'PASSWORD': 'Contraseña',
    'PASS_CONFIRM': 'Confirmación de contraseña',
    'REPEAT': 'Repite Contraseña',
    'LINK': 'Enlace',
    'LIST': 'Lista de usuarios',
    'LOGOUT': 'Cerrar sesión',
    'REQ_USERNAME': 'Nombre de usuario no puede estar en blanco',
    'REQ_MIN_LENGTH': 'El nombre de usuario debe tener al menos 5 caracteres',
    'REQ_ONLY_ALPHANUM': 'El nombre de usuario puede ser solo caracteres alfanuméricos',
    'REQ_EMAIL': 'Email no puede estar vacío',
    'REQ_VALID_EMAIL': 'Por favor ingrese su dirección de correo electrónico válida',
    'REQ_PASS': 'Contraseña de usuario no puede estar en blanco',
    'REQ_PASS_MIN_LENGHT': 'La contraseña debe tener un mínimo de 8 caracteres de longitud',
    'REQ_NO_MATCH': 'La contraseña y la contraseña repetida no coinciden',
    'REQ_ACCOUNT': 'La Cuenta no puede estar vacía',
    'CREATE_ROLE': 'La función Atleast 1 debe crearse en la configuración para crear usuarios.',
    'REQ_ROLE': 'El rol no puede estar vacío',
    'ROLE': 'Papel',
    'ROLES': 'Roles',
    'SELECT_ROLE': 'Por favor seleccione un rol',
    'SELECT_TEAM': 'Por favor seleccione un equipo',
    'TEAM': 'Equipo',
    'T_END_DATE': 'Datos finales de prueba',
    'USERNAME': 'Usuario',
    'LAST_LOGIN': 'Último acceso'
  },
  'ACCOUNT': {
    'ADD_NEW': 'Agregar nueva cuenta',
    'CURRENT_SALESFORCE_ORG': 'Organización actual de Salesforce:',
    'CURRENT_SALESFORCE_URL': 'URL',
    'NAME': 'Cuenta Nombre',
    'LIST': 'Cuenta Lista',
    'VALID_BLANK': 'El nombre de la cuenta no puede estar en blanco.',
    'VALID_EXIST': 'Nombre de cuenta ya existe.',
    'VALID_MIN': 'El nombre de la cuenta debe tener una longitud mínima de 5 caracteres.',
    'ACCOUNT_TYPE': 'Tipo de cuenta',
    'OCR_ENGINE': 'Ocr Engine',
    'PROCESS_TYPE': 'Tipo de proceso',
    'END_DATE': 'Fecha final',
    'VALID_OCR_ENGINE': 'Select an Ocr Engine.',
    'VALID_ACCOUNT_TYPE': 'Seleccione un tipo de cuenta.',
    'VALID_END_DATE': 'Proporcionar una fecha de finalización válida.',
    'VALID_EMAIL': 'Proporcionar un correo electrónico válido (s).',
    'VALID_PROCESS_TYPE': 'Seleccione al menos 1 tipo de proceso.',
    'EDIT_ACCOUNT': 'Editar cuenta',
    'EMAIL': 'Email',
    'REASON': 'Razón',
    'ERRORS': 'ERRORES',
    'EMAIL_FORMAT': 'Formato de correo inválido.',
    'EMAIL_DIFF_ACC': 'Correo electrónico utilizado con una cuenta diferente.',
    'UPLOAD_LOGO': 'Subir logotipo',
    'ACCOUNT_LOGO': 'Logotipo de la cuenta',
    'DELETE_CONTENT': '¿Quieres borrar?'
  },
  'USER_DROPDOWN': {
    'PROFILE': 'Perfil',
    'ADMINS': 'administradores',
    'LOGS': 'bitácora',
    'SETTINGS': 'ajustes',
    'LOGOUT': 'cerrar sesión'
  },
  'FAB_TITLES': {
    'ADD_NEW_USER': 'añadir nuevo usuario',
    'ADD_TEMPLATE': 'añadir plantilla',
    'EXPORT': 'Exportar',
    'NEW_ACCOUNT': 'Nueva cuenta',
    'UPLOAD_FORM': 'cargar formulario'
  },
  'ROUTE_NAME': {
    'Accounts': 'Cuentas',
    'Admin': 'Administración',
    'Users': 'Usuarios',
    'Add a New User': 'Añadir un nuevo usuario',
    'Add New Account': 'Añadir nueva cuenta',
    'Configure': 'Configurar',
    'Dashboard': 'tablero de mandos',
    'Edit Account': 'Editar cuenta',
    'Edit User': 'editar usuario',
    'Form Status': 'Estado del formulario',
    'Log History': 'Historial de registro',
    'New Template': 'Nueva plantilla',
    'Reports': 'Flujo de trabajo',
    'Register': 'Registrar',
    'Template Listing': 'Listado de plantillas',
    'Train': 'Entrenar',
    'Sign In': 'Registrarse',
    'Upload Form': 'cargar formulario',
    'Form Doc': 'Verificación',
    'Verification': 'Verificación',
    'Forms': 'formas',
    'Reports Insights': 'Reports Insights',
    'My Profile': 'mi perfil',
    'MODELS': 'Modelos',
    'page-not-found': '',
    'Features': 'Características'
  },
  'PROFILE': {
    'ROLES': {
      'UNMATCHED': 'No Coincidente',
      'SUPERADMIN': 'súper administrador',
      'ADMIN': 'administrador',
      'TYPE_SELECT': 'Seleccione el tipo de cuenta',
      'TRIAL': 'Cuenta de prueba',
      'SUBS_ACC': 'Cuenta suscrita'
    },
    'ACCNAME': {
      'DEFAULT': 'defecto'
    },
    'ACCOUNT_INFO': 'Información de la cuenta',
    'ACCOUNT_SET': 'Configuraciones de la cuenta',
    'EMAIL_NOTIFY': 'Notificar al usuario por correo electrónico',
    'ENTER_USER': 'Introduzca su nombre de usuario',
    'ENTER_PASS': 'Introduzca nueva contraseña',
    'INFO': 'información del perfil',
    'MEMBERS': 'Miembros',
    'UPDATE_SUCCESS': 'perfil actualizado con éxito',
    'WRONG_PASSWORD': 'Las credenciales que proporcionó no eran correctas'
  },
  'COMMON': {
    'GO_BACK': 'Regresa',
    'OKAY': 'BUENO',
    'FILE_ERROR': 'Error al analizar el archivo',
    'PROCESS_ORDER_INFO': 'Docx utiliza dos técnicas para encontrar una plantilla coincidente para un formulario cargado. Son código de barras y coincidencia de imagen. La técnica de código de barras es donde el sistema busca las plantillas que tienen un tipo de código de barras similar al del formulario y Image Match es donde busca características similares entre la plantilla y las imágenes del formulario. Dependiendo del orden de procesamiento, el sistema prioriza la técnica que se utilizará. Por ejemplo, si el orden de procesamiento de Barcode es 1, se prefiere primero la técnica de Barcode y luego Image Match.',
    'MODEL_EXIST': 'El nombre del modelo ya existe',
    'ADD_MODEL': 'Agregar nuevo modelo',
    'NEW_MODEL': 'Nuevo modelo',
    'VERSION': 'Versión',
    'CHOOSE_FILE': 'Elija el archivo',
    'ACCEPT': 'Aceptar',
    'ACCEPTED': 'Aceptado',
    'ACCOUNT': 'Cuenta',
    'ACCOUNT_TYPE': 'Tipo de cuenta',
    'ACTION': 'Acción',
    'ACTIONS': 'Comportamiento',
    'ACTIVATE': 'Haga clic para activar',
    'ADD': 'Añadir',
    'ALERT': 'ALERTA',
    'APPROVE': 'Aprobar',
    'CANCEL': 'Cancelar',
    'CHANGE': 'Cambio',
    'CLEAR': 'Claro',
    'CLOSE': 'Cerca',
    'CLONE': 'Clon',
    'CONFIRM': 'Confirmación',
    'DATE_RANGE': 'Rango de fechas',
    'DATE_START': 'Fecha de inicio',
    'DATE_END': 'Fecha final',
    'DAY': 'Día',
    'DEACTIVATE': 'Haga clic para desactivar',
    'DELETE': 'Borrar',
    'DELETE_CONFIRM': 'Supprimer la confirmation',
    'DELETE_PERMANENTLY': 'borrar permanentemente',
    'DEL_AUTHCONFIG': 'No puede utilizar este Id. De cliente y este secreto de cliente después de la eliminación. ¿Estas seguro que quieres borrarlo?',
    'DEL_AUTO_CORRECT': 'Esta acción eliminará las funciones de corrección automática y el historial de este campo. ¿Estas seguro que quieres borrarlo?',
    'DEL_AUTO_CORRECT_HISTORY': 'Esta acción eliminará todos los campos de autocorrección del diccionario. ¿Estas seguro que quieres borrarlo?',
    'DEL_ORTFMAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campo ORTF de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_HL7MAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campo HL7 de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_SERVICEVALIDATION': 'Esta acción eliminará permanentemente todas las validaciones de servicio de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_CUSTOMVALIDATION': 'Esta acción eliminará permanentemente todas las validaciones de servicio de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'DEL_SERVICEMAPPING': 'Esta acción eliminará permanentemente todas las asignaciones de campos externos de esta plantilla. ¿Estas seguro que quieres borrarlo?',
    'QBS': 'Exportar a QuickBooks',
    'SLSFRC': 'Exportar a Salesforce',
    'REMS': 'Exportar a Rems',
    'CSV': 'Descargar como CSV',
    'HL7': 'Descargar como HL7',
    'FTP': 'Descargar como FTP',
    'OTRF': 'Descargar como OTRF',
    'EHR': 'Exportar a EHR',
    'FHIR': 'Ver datos FHIR',
    'FILTER_BY': 'Filtrado por',
    'EDT_USR': 'editar usuario',
    'MSG_ERROR_DATE': 'Fecha invalida',
    'MSG_PERM': 'El usuario será eliminado permanentemente del sistema.',
    'MSG_PERM_DEL': 'No puedes deshacer esta acción. ¿Estas seguro que quieres borrarlo?',
    'MSG_DEL': 'Esta acción eliminará los usuarios, roles, plantillas, formularios, mapas de servicio, configuración, etc. de la cuenta.',
    'DESCRIPTION': 'Descripción',
    'ESM': 'Los campos de plantilla no se asignan con el objeto de Salesforce. Por favor revise la configuración',
    'TM': 'Los campos de plantilla no se crean. Amablemente cree campos en la plantilla',
    'DONE': 'Terminado',
    'EDIT': 'Editar',
    'EXPIRES_AT': 'Vence a las',
    'EXPORT': 'Exportar',
    'FILE': 'Archivo',
    'FORM': 'Formar',
    'GENERATE': 'Generar',
    'GROUP_NAME': 'Nombre del grupo',
    'INTEGRATION_EMAILS': 'Correos electrónicos de integración',
    'INVALID_FILE': 'Archivo inválido. (El archivo debe estar en formato de .jpg, .jpeg, .png, .pdf, .tiff)',
    'LIST': 'Lista',
    'MARK_VERIFIED': 'Marca verificada',
    'MSG_CSV_LOG_DAYS': 'El rango máximo permitido es de un mes',
    'MSG_CSV_LOG_DAYS_ERROR': 'Por favor seleccione menos de 31 días',
    'MSG_EXPIRED': 'La sesión expiró, por favor inicie sesión para continuar',
    'MSG_RETRY': 'Algo salió mal. Por favor, intenta de nuevo',
    'MSG_REPROS': 'El formulario solicitado está siendo reprocesado. Por favor, espere.',
    'MSG_DRAW': 'Por favor habilite dibujar antes de crear formas ...',
    'MSG_INACTIVE': 'El servicio solicitado actualmente no está activo. Lo siento por los inconvenientes ocasionados.',
    'MSG_CREATE': 'Creado con éxito',
    'MSG_UPDATE': 'Actualizado exitosamente.',
    'MSG_DELETE': 'Se ha eliminado correctamente.',
    'MSG_DELETE_HISTORY': 'Eliminado correctamente del diccionario',
    'MSG_DELETE_ERR': 'Error al eliminar. Inténtalo de nuevo.',
    'MSG_FIELD_DEL': 'Se elimina el mapa de campo',
    'MSG_LOGIN': 'Por favor inicie sesión para acceder a la página solicitada',
    'MSG_LOGIN_SUCESS': 'Ha iniciado sesión con éxito. Bienvenido ',
    'MSG_USER_NF': '¡Usuario no encontrado!',
    'MSG_SERVER_UA': '¡Servidor no disponible!',
    'MSG_LOGIN_FAIL': 'Algo salió mal. El inicio de sesión ha fallado',
    'MSG_LOGOUT': 'Desconectado con éxito',
    'MSG_USER_UPDATE': 'Usuario actualizado correctamente.',
    'MSG_SIGNUP_FAIL': 'Algo salió mal. El registro ha fallado',
    'MSG_DATA_UPDATE': 'Datos actualizados exitosamente',
    'MSG_USER_CREATE': 'Usuario creado con éxito.',
    'MSG_ERROR': 'Ocurrió un error. Inténtalo de nuevo.',
    'MSG_FORM_REQ': 'O bien, no tiene acceso para ver el formulario / Formulario solicitado no encontrado.',
    'MSG_FETCH_ERR': 'Algo salió mal al buscar datos de formulario.',
    'MSG_PROCESS_FAIL': 'Procesamiento fallido, por favor intente de nuevo.',
    'MSG_FILE_LIMIT': 'El límite máximo de archivos es 5.',
    'MSG_TEMP_FILE_LIMIT': 'El límite máximo de archivos es 1.',
    'MSG_ACC_CREATE': 'Cuenta creada con éxito.',
    'MSG_SUCESS_ACC': 'Cuenta creada con éxito. Por favor, registrese',
    'MSG_EDIT_N_A': 'No permitido editar administrador',
    'MSG_ACC_SUCESS': 'Cuenta actualizada con éxito.',
    'MSG_UPD_FAIL': 'Algo salió mal. Actualización fallida.',
    'MSG_REQ_FIELD': 'Este es un campo obligatorio',
    'MSG_KEY_UNIQUE': 'La clave debe ser única.',
    'MSG_SELECT_TYPE': 'Por favor seleccione tipo',
    'MSG_SELECT_CHILD': 'Seleccione los hijos para eliminar junto con el grupo:',
    'NAME': 'Nombre',
    'NEW': 'Nuevo',
    'NO': 'No',
    'ADD_NPI_GROUPING': 'Agregar agrupación de NPI',
    'NOTIFICATION_EMAILS': 'Emails de notificación',
    'ENTER_MULTIPLE_EMAILS': 'Ingrese un correo electrónico separado por comas',
    'NOTIFY_MSG': 'Tienes {len} notificaciones',
    'NO_RECORD': 'No hay registros para mostrar',
    'OF': 'de',
    'PENDING': 'Pendiente',
    'PROCESS': 'Procesar',
    'PROCESSED': 'Procesada',
    'PRESCRIBER_FIRST_NAME': 'primer nombre del prescriptor',
    'PRESCRIBER_LAST_NAME': 'Apellido del prescriptor',
    'PRESCRIBER_NAME': 'Nombre del prescriptor',
    'REJECT': 'Rechazar',
    'REJECTED': 'Rechazado',
    'REQ_FIELD_WARNING': ' campos externos obligatorios para ser mapeados',
    'RESET': 'Reiniciar',
    'RESIZE': 'Redimensionar',
    'SELECT': 'Seleccionar',
    'SAVE': 'Salvar',
    'SAVE_ALERT': 'Hay algunos cambios no guardados, guárdelos antes de salir.',
    'SHOW_TABLE': 'Mostrar tabla',
    'STATUS': 'Estado',
    'SUBMIT': 'Enviar',
    'TITLE': 'Nombre del la plantilla',
    'UPDATE': 'Actualizar',
    'UPLOAD': 'Subir',
    'UNBLOCK': 'Desatascar',
    'UNMATCHED': 'No coinciden',
    'USERS': 'Usuarios',
    'VALIDATE_UPDATE': 'Validar y actualizar',
    'VERIFY': 'Verificar',
    'VERIFY_DOCUMENT': 'Verificar documento',
    'VERIFIED': 'Verificado',
    'VIEW_FORMS': 'Ver formularios',
    'YES': 'Sí',
    'SUBSCRIBE': 'Suscribir',
    'UNSUBSCRIBE': 'Darse de baja',
    'UNAUTHORIZED': 'No autorizado!',
    'UNMATCH': 'El formulario no coincide con ninguna plantilla',
    'WEEK': 'Semana',
    'ENTER_PASSWORD': 'Introducir la contraseña',
    'WRONG_PASSWORD': 'Contraseña incorrecta',
    'Last Edited By': 'Última edición por',
    'Enabled': 'Activado'
  },
  'PROCESS_ROLES': {
    'BARCODE': 'Código de barras',
    'IMAGE_MATCH': 'Coincidencia de imagen',
    'FORCE_TEMPLATE': 'Plantilla de fuerza',
    'PLAIN_TEXT': 'Texto sin formato'
  },
  'INVOICE': {
    'SIGN_INVOICE': 'FACTURA DE FIRMA',
    'SIGN': 'Firmar',
    'ACCOUNT': 'Cuenta',
    'ACCOUNTING_UNIT': 'Unidad de contabilidad',
    'TOTAL_AMOUNT': 'Cantidad total',
    'ACC_REQ': 'Seleccione una cuenta',
    'ACC_UNIT_REQ': 'Seleccione una unidad contable',
    'AMT_REQ': 'Se requiere la cantidad total',
    'MIN_AMT': 'La cantidad total debe ser mayor o igual a cero',
    'SIGN_SUCCESSFUL': 'Firmado con éxito la factura.',
    'APPROVAL_SUCCESSFUL': 'Aprobado con éxito la firma.',
    'APPROVE_SIGN': 'APROBAR LA VERIFICACIÓN',
    'APPROVE': 'Aprobar',
    'NOTES': 'Notas'
  },
  'TEAMS': {
    'TEAM': 'Equipo',
    'TEAMS': 'Equipos',
    'ADD_NEW_TEAM': 'Agregar nuevo equipo',
    'CREATE_TEAM': 'Crear equipo',
    'CREATE': 'Crear',
    'NAME': 'Nombre',
    'DESCRIPTION': 'Descripción',
    'REQUIRED_FIELD': 'Campo requerido',
    'NO_USER_FOUND': 'No se han encontrado {ROLE}. Agregue un nuevo {ROLE}.',
    'NO_USER_ADDED': 'No se agregaron {ROLE} al equipo. Agregue un {ROLE}.',
    'INCOMPLETE': 'El equipo está incompleto. Faltan algunos de los roles en la jerarquía.',
    'DELETE_CONFIRM': '¿Estás seguro de que deseas eliminar este equipo de forma permanente?'
  },
  'Accounts': 'Cuentas',
  'Add New': 'Agregar nuevo',
  'Add User': 'Agregar usuario',
  'Admin': 'Administración',
  'Admins': 'Administradores',
  'Aduit': 'Auditoría',
  'Analytics': 'Analítica',
  'Configure': 'Configurar',
  'Forms': 'Formularios',
  'Home': 'Casa',
  'List': 'Lista',
  'Logs': 'Registros',
  'New': 'Nuevo',
  'New User': 'Nuevo Usuario',
  'Processed': 'Procesada',
  'Reports': 'Informes',
  'Settings': 'Configuraciones',
  'Models': 'Modelos',
  'Super Admin': 'súper administrador',
  'Templates': 'Plantillas',
  'Trails': 'Caminos',
  'Upload Form': 'cargar formulario',
  'Users': 'Usuarios',
  'Verification': 'Verificación',
  'Workflow': 'Flujo de trabajo',
  'Mappings': 'Mapeos',
  'Add new mapping': 'Añadir nuevo mapeo'
}



// WEBPACK FOOTER //
// ./src/lang/es.js